import React from 'react';
import {
    createBrowserRouter,
    RouterProvider,
    Route,
    createRoutesFromElements,
    Navigate
} from 'react-router-dom';

import Root from './components/Root';
import Me from './components/Me';
import Partners from './components/Partners';
import Users from './components/Users';
import Balance from './components/Balance';
import MessageStats from './components/MessageStats';
import ProtectedRoute from './components/ProtectedRoute';
import Roles from './components/Roles';
import Tariffs from './components/Tariffs';
import PartnerTariffs from './components/PartnerTariffs';
import Templates from './components/Templates';
import Campaigns from './components/Campaigns';
import Reports from './components/Reports';

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/" element={<Root />}>
                <Route index path="me" element={
                    <Me />
                } />
                <Route path="partners" element={
                    <ProtectedRoute permissions={[
                        "partners.read",
                        "partners.create",
                        "partners.update",
                        "partners.disable"
                    ]}>
                        <Partners />
                    </ProtectedRoute>
                } />
                <Route path="users" element={
                    <ProtectedRoute permissions={["users.manage"]}>
                        <Users />
                    </ProtectedRoute>
                } />
                <Route path="balance" element={
                    <ProtectedRoute permissions={["balance.read"]}>
                        <Balance />
                    </ProtectedRoute>
                } />
                <Route path="messages" element={
                    <ProtectedRoute permissions={["messages.read"]}>
                        <MessageStats />
                    </ProtectedRoute>
                } />
                <Route path="templates" element={
                    <ProtectedRoute permissions={["templates.read", "templates.manage"]}>
                        <Templates />
                    </ProtectedRoute>
                } />
                <Route path="campaigns" element={
                    <ProtectedRoute permissions={[
                        "campaigns.read",
                        "campaigns.create",
                        "campaigns.manage"
                    ]}>
                        <Campaigns />
                    </ProtectedRoute>
                } />
                <Route path="reports" element={
                    <ProtectedRoute permissions={["reports.read", "messages.read"]}>
                        <Reports />
                    </ProtectedRoute>
                } />
                {/* <Route path="roles" element={
                    <ProtectedRoute permissions={["roles.manage"]}>
                        <Roles />
                    </ProtectedRoute>
                } /> */}
                <Route path="tariffs" element={
                    <ProtectedRoute permissions={[
                        "tariffs.read",
                        "tariffs.manage"
                    ]}>
                        <Tariffs />
                    </ProtectedRoute>
                } />
                <Route path="partner-tariffs" element={
                    <ProtectedRoute permissions={[
                        "partner-tariffs.read",
                        "partner-tariffs.manage"
                    ]}>
                        <PartnerTariffs />
                    </ProtectedRoute>
                } />
            </Route>

            <Route path="login" element={<Root />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </>
    )
);

export default function App() {
    return <RouterProvider router={router} />;
}
